export default __webpack_public_path__ + "static/media/kitchen4-afterF-1440w.9f48d36d.webp";